import React, { useState, useEffect } from "react";
import {
  editSubscription,
  getSubscription,
  createSubscription,
  publishSubscription,
} from "../../api/api";
import OfferList from "../list/offerList";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import Select from "react-select";
import LabelImage from "../cards/image";
import { NecStore } from "../../store/necStore";
import ToolTip from "../tooltip/tooltip";
// import { UserLang } from "../../store/userStore";

const Subscription = (props) => {
  const [list, setList] = useState([]);

  const page = {
    SRMName: "",
    SRMKey: "",
    SRMSecret: "",
    uuid: "",
    customPayment: false,
    checkoutUrl: "",
    customLogin: false,
    customLoginUrl: "",
    otp: false,
    otpKey: "",
    plans: list,
  };
  const menuPic = [
    {
      value: "Inplayer",
      label: (
        <LabelImage
          url={
            "https://developers.inplayer.com/img/inplayer-logo-new-dark-blue.png"
          }
          name={"Inplayer"}
          height={"30px"}
        >
          {" "}
        </LabelImage>
      ),
    },
  ];
  /* eslint-disable no-unused-vars */
  const [allIcon, setIcon] = useState(menuPic);
  const [sub, setSub] = useState(page);

  const [subCount, setSubCount] = useState("");
  const [subStatus, setSubStatus] = useState(0);
  const role = NecStore.useState((s) => s.setting);
  const [loading, setLoading] = useState(false);
  // const lan = UserLang.useState((s) => s.lan);
  const [lan] = useState("ltr");

  useEffect(() => {
    const elementDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const pageid = props.match.params.id;
      const result = await getSubscription(pageid).then(
        (result) => {
          setSub(result.data);
          setLoading(false);
        },
        (error) => {
          const obj = {
            status: error.response.data.error.status,
            message: error.response.data.error.message,
          };
          setSubCount(obj.message);
          setSubStatus(obj.status);
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    /* eslint-disable no-unused-vars */

    elementDetail();

    /* eslint-disable no-unused-vars */
  }, [props.match.params.id]);

  const handleChange = (value, evt) => {
    const val = value.value;
    setSub({
      ...sub,
      [evt.name]: val,
    });
  };

  const ChangeItem = (evt) => {
    const value = evt.target.value;
    setSub({
      ...sub,
      [evt.target.name]: value,
    });
  };

  const draft = async (event) => {
    setLoading(true);
    event.preventDefault();
    if (subStatus === 404 || subCount === "No Subscription Schema Exists") {
      /* eslint-disable no-unused-vars */
      const result = await createSubscription(sub).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    } else {
      const result = await editSubscription(sub).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    }
  };

  const publish = async (event) => {
    // setDisable(true);
    if (role.production === true) {
      setLoading(true);
      event.preventDefault();

      /* eslint-disable no-unused-vars */
      const result = await publishSubscription().then(
        (result) => {
          toastr.success("Successfully Published", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    } else {
      toastr.error("Preview Environment is off", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  const updateVisiblity = (event) => {
    setSub({
      ...sub,
      [event.target.name]: event.target.checked,
    });
  };

  const handleListChange = (edit) => {
    const opt = edit.map((item) => ({
      planid: item.value,
      planRef: item.label,
      planOrder: item.order,
    }));
    setList(opt);
    /*eslint-disable no-useless-computed-key */

    setSub({
      ...sub,
      ["plans"]: opt,
    });

    /*eslint-disable no-useless-computed-key */
  };

  //
  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Subscription Schema
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={draft}>
                    <div className="row">
                      <div
                        className="col-sm-6"
                        dir={lan === "rtl" ? "rtl" : "ltr"}
                      >
                        {/* text input */}
                        <label
                          className={
                            lan === "rtl" ? "float-right" : "float-left"
                          }
                        >
                          {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                          Select SRM
                          {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                        </label>
                        <Select
                          name="SRMName"
                          className={
                            lan === "rtl"
                              ? "form-control inside-select float-right"
                              : "form-control inside-select float-left"
                          }
                          options={allIcon}
                          onChange={(value, event) =>
                            handleChange(value, event)
                          }
                        ></Select>

                        <div
                          className="row"
                          style={{
                            marginTop: "100px",
                            backgroundColor: "#f2f2f2",
                            marginLeft: "5px",
                          }}
                        >
                          <div
                            className="col-md-6"
                            style={{ marginTop: "20px", marginLeft: "2px" }}
                          >
                            <span>{sub.SRMName}</span>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Enter Client Key available on Inplayer"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Client Key&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Enter Client Key available on Inplayer"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="SRMKey"
                            className="form-control inside-form"
                            placeholder="API Key ..."
                            defaultValue={sub.SRMKey}
                            onChange={ChangeItem}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Enter Client Secret available on Inplayer"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Client Secret&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Enter Client Secret available on Inplayer"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="SRMSecret"
                            className="form-control inside-form"
                            placeholder="API Secret ..."
                            defaultValue={sub.SRMSecret}
                            onChange={ChangeItem}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Enter UUID available on Inplayer"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;UUID&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Enter UUID available on Inplayer"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="uuid"
                            className="form-control inside-form"
                            placeholder="UUID ..."
                            defaultValue={sub.uuid}
                            onChange={ChangeItem}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Check Out URL
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="checkoutUrl"
                            className="form-control inside-form"
                            placeholder="Checkout URL ..."
                            defaultValue={sub.checkoutUrl}
                            onChange={ChangeItem}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"customPayment"}
                              id={"customPayment"}
                              defaultChecked={sub.customPayment}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className={
                                lan === "rtl"
                                  ? "custom-control-label not-bold float-right"
                                  : "custom-control-label not-bold float-left"
                              }
                              htmlFor={"customPayment"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Custom Payment
                              {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Custom Login URL
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="customLoginUrl"
                            className="form-control inside-form"
                            placeholder="Custom Login Url ..."
                            defaultValue={sub.customLoginUrl}
                            onChange={ChangeItem}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"customLogin"}
                              id={"customLogin"}
                              defaultChecked={sub.customLogin}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className={
                                lan === "rtl"
                                  ? "custom-control-label not-bold float-right"
                                  : "custom-control-label not-bold float-left"
                              }
                              htmlFor={"customLogin"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Custom Login
                              {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"otp"}
                              id={"otp"}
                              defaultChecked={sub.otp}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className={
                                lan === "rtl"
                                  ? "custom-control-label not-bold float-right"
                                  : "custom-control-label not-bold float-left"
                              }
                              htmlFor={"otp"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {lan === "rtl" && (
                                <ToolTip
                                  info={
                                    "Enable default OTP Conformation for the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                              &nbsp;Enable OTP Confirmation&nbsp;
                              {!(lan === "rtl") && (
                                <ToolTip
                                  info={
                                    "Enable default OTP Conformation for the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "API Key avilable from two factor account"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Two Factor OTP API Key&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "API Key avilable from two factor account"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="otpKey"
                            className="form-control inside-form"
                            placeholder="API Key"
                            defaultValue={sub.otpKey}
                            onChange={ChangeItem}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2 mt-2"></div>
                    <div className="card-header" style={{ padding: "0" }}>
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {lan === "rtl" && (
                          <ToolTip
                            info={"Subscription plans available on Inplayer"}
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                        &nbsp;Subscription Plans&nbsp;
                        {!(lan === "rtl") && (
                          <ToolTip
                            info={"Subscription plans available on Inplayer"}
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                      </label>
                    </div>
                    <OfferList
                      dir={lan === "rtl" ? "rtl" : "ltr"}
                      url={props.match.params.id}
                      onChange={handleListChange}
                      listData={sub.plans}
                      {...props}
                    ></OfferList>

                    <div className="row mb-2 mt-2"></div>

                    <div className="row">
                      <div className="col-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "float-left btn-group btn-group-md"
                              : "float-right btn-group btn-group-md"
                          }
                          role="group"
                        >
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px", marginRight: "6px" }}
                          >
                            Save
                          </button>
                          <button
                            type="button"
                            onClick={publish}
                            className="btn btn-success"
                            style={{ width: "100px", marginRight: "6px" }}
                            disabled={!role.production === true ? true : false}
                            hidden={!role.production === true ? true : false}
                          >
                            Publish
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default Subscription;
